import React, { memo } from 'react';

import { useTranslation } from '@mint-lib/i18n';
import { Tabs, TabsList, TabsTrigger } from '@mint-lib/tw-components';

import {
  IntegrationStatusFilters,
  statusFilters,
} from '../../../constants/integrationsList.js';

type FilterType = {
  activeStatus: IntegrationStatusFilters;
  onFilterChange(status: IntegrationStatusFilters): void;
};

const Filters: React.FC<FilterType> = ({ activeStatus, onFilterChange }) => {
  const { t } = useTranslation('@myn/integrations_v2');

  return (
    <div>
      <Tabs value={activeStatus} className="w-full">
        <TabsList>
          {statusFilters(t).map((filter) => (
            <TabsTrigger
              key={filter.id}
              value={filter.id}
              onClick={() => onFilterChange(filter.id)}
              data-testid={filter.id}
              data-dd-action-name="filter integrations"
            >
              {filter.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </Tabs>
    </div>
  );
};

export default memo(Filters);
